import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
	FooterLinkItems,
	FooterLinkTitle,
	FooterLink,
	FooterLogo,
	SocialIcon,
	FooterRights,
	FooterSocialIcon,
	FooterWrapper,
	FooterAddress,
	FooterColumn,
	FooterGrid,
	FooterMap,
} from './FooterStyles';
import { footerData, footerSocialData } from '../../data/FooterData';
import { Row, Section } from '../../globalStyles';
import logo from '../../assets/logo2.0.png'

function Footer() {
	const { t } = useTranslation();
	return (
		<Section padding="3rem 0 1.5rem 0">
			<FooterWrapper>
				<FooterGrid>
					{/* Columna izquierda con logo y navegación */}
					<FooterColumn id="footerInfo">
						<div>
							<FooterLogo 
								to="/" 
								onClick={() => {
									window.scrollTo({
										top: 0,
										behavior: "smooth"
									});
								}}>
								<SocialIcon src={logo} />
								Radixagro
							</FooterLogo>

							{/* Links de navegación */}
							<Row style={{ justifyContent: 'flex-start', marginTop: '1rem' }}>
								{footerData.map((footerItem, index) => (
									<FooterLinkItems key={index}>
										<Link 
											style={{textDecoration: 'none', color: 'white'}} 
											to={footerItem.links}
											onClick={() => {
												window.scrollTo({
													top: 0,
													behavior: "smooth"
												});
											}}>
											<FooterLinkTitle>{t(`footer_data.${index}.title`)}</FooterLinkTitle>
										</Link>
									</FooterLinkItems>
								))}
							</Row>

							<Row align="center" margin="1rem 0 0 0" gap="1rem">
								{footerSocialData.map((social, index) => (
									<FooterSocialIcon
										key={index}
										href={social.href}
										target="_blank"
										rel="noreferrer"
										aria-label={social.name}
									>
										{social.icon}
									</FooterSocialIcon>
								))}
							</Row>
						</div>
					</FooterColumn>

					{/* Columna derecha con dirección y mapa */}
					<div>
						<FooterAddress>
							Thames 122, Villa Adelina, Buenos Aires
						</FooterAddress>
						<FooterMap>
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3288.1088451658015!2d-58.546249423774285!3d-34.50012475203558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb07cba0a95d7%3A0x5227fd046c7da218!2sThames%20122%2C%20B1607%20Villa%20Adelina%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1759866436693!5m2!1ses!2sar"
								allowFullScreen=""
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
								title="Radixagro Location"
							/>
						</FooterMap>
					</div>
				</FooterGrid>
				<FooterRights>Radixagro © 2023</FooterRights>
			</FooterWrapper>
		</Section>
	);
}

export default Footer;